import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import CCrud from "components/Molecules/Crud";
import { initialValues, structure, validationSchema } from "./structure";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Box, Stack } from "@mui/material";
import Breadcrumb from "components/Atoms/SharedComponents/Breadcrumbs/Breadcrumb";
import AddIcon from "@mui/icons-material/Add";
import EventTypeDetails from "./details";

const EventTypesTemplate = ({
  handlePageChange,
  data,
  details,
  count,
  handelSubmit,
  filterList,
  actionsList,
  breadcrumbs,
  setFilterObj,
  rowData,
  paginationPage,
  headerChildren,
  modalComponents,
  openDeleteModal,
  setOpenDeleteModal,
  handleDeleteRequest,
  can_create,
  can_update,
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  let [searchParams] = useSearchParams();
  const id = searchParams.get("id");
  const [supportedLang] = useState("en");

  return (
    <Box>
      <Stack
        direction="row"
        alignSelf="start"
        justifyContent="start"
        gap={2}
        width="100%"
      >
        <Breadcrumb data={breadcrumbs} />
      </Stack>
      <CCrud
        DetailsComponent={
          <EventTypeDetails details={details} canUpdate={can_update} />
        }
        table={{
          list: data,
          listTitle: t("events_event_types.list_title"),
          createBtnTitle: can_create && t("events_event_types.add"),
          CreateBtnIcon: AddIcon,
          createBtnFun: () => navigate("?type=form"),
          columns: [
            { accessor: "id", Header: "#" },
            { accessor: "image_url", Header: t("common.image") },
            {
              accessor: "name_en",
              Header: t("events_event_types.name_en"),
              sort: true,
            },
            {
              accessor: "name_ar",
              Header: t("events_event_types.name_ar"),
              sort: true,
            },
            {
              accessor: "display_priority",
              Header: t("events_event_types.display_priority"),
              sort: true,
            },
            {
              accessor: "is_active_label",
              Header: t("events_event_types.is_active"),
              sort: true,
            },
            {
              accessor: "created_at",
              Header: t("details.created_at"),
              sort: true,
            },
            { accessor: "Actions", Header: t("cart_logs.actions") },
          ],
          isSearch: true,
          searchInputPlaceholder: t("events_event_types.search_placeholder"),
          isChecked: false,
          total_count: count,
          setFilterObj,
          className: "organization-table main-table",
          paginationPage: paginationPage,
          handlePageChange,
          rowData: rowData,
          filterList,
          actionsList,
          headerChildren,
          details,
          openDeleteModal,
          setOpenDeleteModal,
          handleDeleteRequest,
          emptyListMsg: t("events_event_types.empty"),
        }}
        form={{
          initialValues: !id ? {} : initialValues(details, supportedLang),
          structure: () => structure(supportedLang, null, t),
          validationSchema: validationSchema,
          title: id ? t("events_event_types.edit") : t("events_event_types.add"),
          submitTitle: id
            ? t("admin_users.btn_update")
            : t("admin_users.btn_add"),
          onSubmit: handelSubmit,
          className: { form: "main-form", actionButton: "main-form-buttons" },
        }}
        modalComponents={modalComponents}
      />
    </Box>
  );
};

export default EventTypesTemplate;
